import { Link } from "react-router-dom"
import styled from "styled-components"
import Header from "../Common/Header"
import Footer from "../Common/Footer"

const Main = styled.main`
  min-height: 70vh;
  padding: clamp(4.5rem, 10vw, 7rem) 1rem;
  background: linear-gradient(160deg, #f5f8fb 0%, #e6eef7 100%);
`

const Content = styled.div`
  width: min(900px, 100%);
  margin: 0 auto;
  padding: clamp(2rem, 6vw, 4rem);
  border: 1px solid rgba(27, 117, 188, 0.14);
  border-top: 4px solid ${({ theme }) => theme.primary};
  border-radius: 2px;
  background: #fff;
  box-shadow: 0 24px 60px rgba(13, 65, 114, 0.1);

  h1 {
    color: ${({ theme }) => theme.primaryDark};
    font-size: clamp(2.3rem, 6vw, 3.5rem);
  }

  h2 {
    margin-top: 2rem;
    color: ${({ theme }) => theme.primaryDark};
    font-size: 1.35rem;
  }

  p,
  li {
    line-height: 1.75;
  }

  ul {
    padding-left: 1.2rem;
  }
`

const Updated = styled.p`
  margin: 0.75rem 0 2.5rem;
  color: ${({ theme }) => theme.textSecondary};
`

const ContactLink = styled(Link)`
  display: inline-flex;
  margin-top: 1.5rem;
  padding: 0.85rem 1.25rem;
  border-radius: 2px;
  background: ${({ theme }) => theme.primaryDark};
  color: #fff;
  text-decoration: none;
  font-weight: 700;
`

const TermsOfUse = () => (
  <>
    <Header />
    <Main id="contenu-principal">
      <Content>
        <h1>Conditions d’utilisation</h1>
        <Updated>Dernière mise à jour : 21 août 2026</Updated>

        <p>En consultant ce site, vous acceptez les conditions ci-dessous. Si vous n’y consentez pas, veuillez cesser de l’utiliser.</p>

        <h2>Information générale</h2>
        <p>
          Le contenu du site présente les services de TB Gestion Immobilière et fournit de l’information générale. Il ne constitue pas un avis
          juridique, fiscal ou financier. Les modalités d’un mandat de gestion sont celles du contrat signé avec le client.
        </p>

        <h2>Exactitude et disponibilité</h2>
        <p>
          Nous cherchons à maintenir une information claire et à jour, mais une erreur ou une interruption peut survenir. Les résultats d’un immeuble
          dépendent notamment de son état, de son marché, de ses occupants et des décisions du propriétaire; aucun résultat financier, taux
          d’occupation ou délai n’est garanti par le contenu de ce site.
        </p>

        <h2>Utilisation permise</h2>
        <ul>
          <li>Vous devez utiliser le site et ses formulaires de façon légale et fournir des renseignements exacts.</li>
          <li>Vous ne devez pas tenter de perturber le site, d’accéder à une section protégée ou d’utiliser le contenu à des fins frauduleuses.</li>
          <li>Les textes, éléments visuels et marques du site ne peuvent pas être reproduits à des fins commerciales sans autorisation.</li>
        </ul>

        <h2>Espace TB</h2>
        <p>
          Un accès Espace TB est personnel. Vous devez protéger votre mot de passe, éviter de partager votre session et nous signaler rapidement tout
          accès suspect. Les demandes, messages et photos doivent concerner un logement, un immeuble ou un service pris en charge par TB Gestion
          Immobilière. Le portail facilite le suivi, mais ne remplace pas un appel à la ligne d’urgence lorsqu’une situation présente un danger ou
          exige une intervention immédiate.
        </p>

        <h2>Liens externes</h2>
        <p>
          Des liens peuvent mener à des services tiers. Ceux-ci appliquent leurs propres conditions et politiques; TB Gestion Immobilière n’en
          contrôle pas le contenu.
        </p>

        <h2>Modifications et droit applicable</h2>
        <p>
          Ces conditions peuvent être mises à jour. La version en vigueur est celle publiée sur cette page. Elles sont régies par les lois applicables
          au Québec et au Canada.
        </p>

        <ContactLink to="/nous-contacter">Nous poser une question</ContactLink>
      </Content>
    </Main>
    <Footer />
  </>
)

export default TermsOfUse
